(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-eeat"]) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-ae]');
      if (!root) return;
      var content = root.querySelector('.ae-content');
      var bar = root.querySelector('.ae-progress span');
      var toc = root.querySelector('[data-ae-toc]');
      var desktop = window.matchMedia('(min-width: 1280px)');

      if (toc) {
        var syncToc = function () { if (desktop.matches) toc.open = true; };
        syncToc();
        desktop.addEventListener('change', syncToc);
        toc.querySelector('summary').addEventListener('click', function (e) { if (desktop.matches) e.preventDefault(); });
        toc.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () { if (!desktop.matches) toc.open = false; });
        });
      }

      if (bar && content) {
        var ticking = false;
        var update = function () {
          var r = content.getBoundingClientRect();
          var total = r.height - window.innerHeight * 0.6;
          var read = total > 0 ? (window.innerHeight * 0.4 - r.top) / total : 1;
          read = Math.min(Math.max(read, 0), 1);
          bar.style.transform = 'scaleX(' + read.toFixed(4) + ')';
          ticking = false;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      if (toc && 'IntersectionObserver' in window) {
        var links = Array.prototype.slice.call(toc.querySelectorAll('a'));
        var byId = {};
        links.forEach(function (a) { byId[decodeURIComponent(a.hash.slice(1))] = a; });
        var setActive = function (id) {
          links.forEach(function (l) { l.removeAttribute('aria-current'); });
          if (byId[id]) byId[id].setAttribute('aria-current', 'true');
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
        }, { rootMargin: '0px 0px -70% 0px' });
        content.querySelectorAll('h2[id]').forEach(function (h) { io.observe(h); });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
